import { render, staticRenderFns } from "./FeaturedCompanies.vue?vue&type=template&id=8b35d5e4&scoped=true&"
import script from "./FeaturedCompanies.vue?vue&type=script&lang=js&"
export * from "./FeaturedCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b35d5e4",
  null
  
)

export default component.exports